module.exports = __webpack_public_path__ + "img/choithrams-original-960.4f73a102.png";